module.exports = __webpack_public_path__ + "static/media/record.b4ab5754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/record.svg
// module id = 1374
// module chunks = 0